import styled from "styled-components";

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;

  @media(max-width: 770px) {
    .mobile {
      display: flex;
    }
    .desktop {
      display: none;
    }
  }

  @media(min-width: 770px) {
    .mobile {
      display: none;
    }
    .desktop {
      display: flex;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  background-color: #ffffff;
  @media (max-width: 770px) {
    height: 100%;
    overflow-y: scroll;
    padding: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  @media (max-width: 770px) {
    width: 100%;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const PageWrapper = styled.div`
  width: 860px;
  height: 80vh;
  padding: 0px 30px 0px 60px;
  overflow-y: scroll;

  @media (max-width: 770px) {
    width: 100%;
    height: 100%;
    padding: 30px 5px;
    background-color: #ffffff;
  }
`;

export const MobileImage = styled.div`
  text-align: -webkit-center;
`;

export const ClubImageSectionOne = styled.div`
  width: 100%;
  ${(props) =>
    props.$bravium
      ? `
    display: flex;
    align-items: center;
    gap: 20px;
    @media (max-width: 770px) {
      flex-direction: column;
    }
  `
      : `
    display: flex;
    align-items: center;
    gap: 20px;
    @media (max-width: 770px) {
      flex-direction: column;
    }
  `}
`;

export const ClubImageSectionTwo = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const ClubImageContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 1000px) {
    max-width: 80%;
  }
  @media (max-width: 770px) {
    max-width: 100%;
    img {
      width: 100%;
    }
  }
  @media (max-width: 600px) {
    max-width: 100%;
      img {
      width: 100%;
    }
  }
`;

export const PortalImage = styled.img`
  ${(props) =>
    props.$bravium
      ? `
    width: 100%;
    height: auto;
    border-radius: 12px;
    cursor: pointer;
    transition: opacity 0.2s;
    display: block;
    object-fit: cover;
    &:hover {
      opacity: 0.9;
    }
    @media (max-width: 770px) {
      width: 100%;
      padding: 0px 4px;
    }
  `
      : `
    width: 50%;
    height: auto;
    display: block;
    @media (max-width: 770px) {
      width: 100%;
    }
  `}
`;

export const SubsidioLink = styled.a`
  width: 50%;
  display: block;
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
  @media (min-width: 771px) {
    margin-left: -14px;
  }
  @media (max-width: 770px) {
    width: 100%;
  }
`;

export const SubsidioImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
`;

export const ClubImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
  display: block;
  object-fit: cover;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 770px) {
    padding: 0px 4px;
  }
`;

export const ClubInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px 50px 30px;
  @media (max-width: 770px) {
    max-width: 450px;
  }

  h3 {
    color: #818181;
    font-size: 1rem;
    margin-bottom: 0;
    font-weight: 400;
    font-family:'Roboto';
  }
`;

export const ClubButton = styled.a`
  width: 100%;
  max-width: 165px;
  height: 40px;
  margin-top: 20px;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  outline: none !important;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  padding: ${(props) => props.padding};
  &:hover {
    filter: brightness(90%);
  }
  span {
    color: #ffffff;
  }
`;
